import Vue from "vue"
import Clipboard from "clipboard"

export default function copy(text, event) {
  const clipboard = new Clipboard(event.target, {
    text: () => text
  })

  clipboard.on("success", () => {
    Vue.prototype.$message.success("复制成功！")
    clipboard.destroy()
  })

  clipboard.on("error", () => {
    Vue.prototype.$message.error("复制失败！")
    clipboard.destroy()
  })

  clipboard.onClick(event)
}
